import StripHtml from '../lsp-filters/strip-html-filter';

const striptHtml = new StripHtml();

// TODO remove this complete, problem with CKEditor value which is removed after changing language
function strippedMaxLength(appFactory) {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      smsEnabled: '=',
      strippedForm: '=',
    },
    link: (...args) => {
      args[0].$watch('smsEnabled', (newVal, oldVal) => {
        if (newVal !== oldVal) {
          const maxlength = appFactory.deps.config.smsNotificationPopupMaxCharCountDisabled;
          args[3].$validators.maxlength = (value = '') => striptHtml(value).length <= maxlength;
          args[0].strippedForm[args[2].name].$setValidity('maxlength', striptHtml(args[3].$viewValue).length <= maxlength);
        }
      });
    },
  };
}

strippedMaxLength.$inject = ['appFactory'];

export default strippedMaxLength;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/stripped-max-length.js